var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat-two-bubbles-oval--messages-message-bubble-chat-oval-conversation",
    clipPath: "url(#clip0_115_21872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat-two-bubbles-oval--messages-message-bubble-chat-oval-conversation_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7141 7.14288C15.3244 7.14288 16.8687 7.78256 18.0073 8.92117C19.1458 10.0598 19.7855 11.6041 19.7855 13.2143C19.7894 14.4095 19.4361 15.5785 18.7713 16.5715L19.7855 19.2857L16.3713 18.6715C15.5501 19.0719 14.6493 19.2819 13.7357 19.2857C12.8222 19.2896 11.9196 19.0872 11.0951 18.6937C10.2706 18.3003 9.54558 17.7257 8.97398 17.0132C8.40238 16.3006 7.99895 15.4682 7.79378 14.5779C7.58861 13.6877 7.58695 12.7627 7.78897 11.8718C7.99098 10.9808 8.39144 10.147 8.9605 9.43231C9.52955 8.71766 10.2526 8.14064 11.0756 7.74424C11.8987 7.34784 12.8006 7.14228 13.7141 7.14288Z",
    stroke: "#222222",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.5853 3.58573C13.6233 2.36154 12.3035 1.4678 10.8096 1.02893C9.31578 0.590066 7.72227 0.627921 6.25095 1.13722C4.77964 1.64653 3.50375 2.60193 2.60091 3.87041C1.69808 5.13889 1.21324 6.65733 1.2139 8.2143C1.20947 9.6943 1.64723 11.1419 2.47104 12.3714L1.2139 15.7142L4.24247 15.1714",
    stroke: "#222222",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_21872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon-chat.6e36000330f926e84e746970924a897f.svg";
export { ForwardRef as ReactComponent };